import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CharacterLimitDirective } from './character-limit/character-limit.directive';
import { DatePickerFormatDirective } from './date-picker-format/date-picker-format.directive';
import { MinDateDirective } from './min-date/min-date.directive';
import { PermissionDirective } from './permission/permission.directive';
import { RoleDirective } from './role/role.directive';

@NgModule({
  declarations: [CharacterLimitDirective, MinDateDirective, PermissionDirective, RoleDirective, DatePickerFormatDirective],
  imports: [CommonModule],
  exports: [CharacterLimitDirective, MinDateDirective, PermissionDirective, RoleDirective, DatePickerFormatDirective],
})
export class DirectivesModule {}
